import React from 'react'
import { isMobile } from 'react-device-detect'
import { Motif } from '../../types/motifs'
import { useStrapiTranslation } from '../../utils/useStrapiTranslation'
import MotifSelector from './MotifSelector'

interface Props {
  motif: Motif
}

const MotifInfoSection = ({ motif }: Props) => {
  const { strapiTranslate } = useStrapiTranslation()

  return (
    <div className="h-[var(--hd-img-max)] max-h-[var(--hd-img-max)] overflow-x-hidden overflow-y-hidden [grid-column:2_/_2] [grid-row:1_/_span_2] max-sm:h-auto max-sm:max-h-none max-sm:overflow-y-visible max-sm:pb-0 max-sm:pl-[24px] max-sm:pr-0 max-sm:pt-0 xxl:h-[680px] xxl:max-h-[680px] xxl:p-0">
      <div className="mb-[10px] ml-0 mr-0 mt-[22px] overflow-x-visible xxl:mt-[40px] max-sm:[&_.selector-numbered-text]:font-approach-medium max-sm:[&_.selector-numbered-text]:text-[16px] max-sm:[&_.selector-numbered-text]:leading-[20px] max-sm:[&_.selector-text]:text-[16px] max-sm:[&_.selector-text]:leading-[20px] xxl:[&_.selector-text]:text-[length:var(--fk-selector-size)] xxl:[&_.selector-text]:leading-[20px] max-sm:[&_.selectorButtonWrapper_button]:gap-0 xxl:[&_.selectorButtonWrapper_button]:gap-0">
        {isMobile && window.innerHeight < 600 ? <MotifSelector motif={motif} /> : null}
        <h1 className="mb-[14px] ml-0 mr-0 mt-[14px] font-approach-light text-[length:var(--hd-h1-size)] leading-[1.2] text-black95 [-moz-osx-font-smoothing:grayscale] [-webkit-font-smoothing:antialiased] max-sm:text-[32px] max-sm:leading-[125%] xxl:text-[length:var(--fk-h1-size)]">
          {strapiTranslate(motif, 'title')}
        </h1>
        <p className="m-0 inline rounded-[3px] bg-bgMediumGrey p-[6px] font-approach-regular text-[length:var(--hd-settlement-size)] font-medium leading-[1.6] tracking-[0.62px] text-black70 [-webkit-box-decoration-break:clone] [box-decoration-break:clone] empty:hidden max-sm:text-[17px] max-sm:leading-[1.6] xxl:text-[length:var(--fk-settlement-size)] xxl:leading-[1.6]">
          {strapiTranslate(motif, 'year')}
          {motif.year && (motif.country || motif.region || motif.settlement) ? ' - ' : ''}
          {strapiTranslate(motif, 'country')}
          {motif.country && motif.region ? ', ' : ''}
          {strapiTranslate(motif, 'region')}
          {(motif.region && motif.settlement) ||
          (motif.country && motif.settlement && !motif.region)
            ? ', '
            : ''}
          {strapiTranslate(motif, 'settlement')}
        </p>
        <h2 className="mb-[10px] ml-0 mr-0 mt-[10px] font-approach-regular text-[length:var(--hd-h2-size)] leading-[1.2] text-black95 max-sm:text-[24px] max-sm:leading-[30px] xxl:text-[length:var(--fk-h2-size)]">
          {strapiTranslate(motif, 'subtitle')}
        </h2>
      </div>
      <p className="tags" hidden>
        tags: {motif.tagIds?.length ? motif.tagIds.join(', ') : ''}
      </p>
      <p className="m-0 block h-[490px] w-full whitespace-pre-wrap p-0 font-approach-light text-[length:var(--hd-p-size)] font-normal leading-[1.33] tracking-[0.5px] text-grey40 [overflow-y:clip] max-sm:h-auto xxl:text-[24px]">
        {strapiTranslate(motif, 'description')}
      </p>
    </div>
  )
}

export default MotifInfoSection
